<template>
	<div class="config-form-container">
		<!-- 页面头部 -->
		<div class="page-header">
			<div class="header-content">
				<div class="header-left">
					<div class="back-button" @click="back()">
						<i class="el-icon-arrow-left"></i>
					</div>
					<div class="header-info">
						<h1 class="page-title">
							{{ getPageTitle() }}
						</h1>
						<div class="breadcrumb">
							<span class="breadcrumb-item">轮播图管理</span>
							<i class="el-icon-arrow-right"></i>
							<span class="breadcrumb-current">
								{{ getBreadcrumbText() }}
							</span>
						</div>
					</div>
				</div>
				<div class="header-actions" v-if="type !== 'info'">
					<el-button @click="back()" class="cancel-btn">
						<i class="el-icon-close"></i>
						取消
					</el-button>
					<el-button type="primary" @click="onSubmit" :loading="submitLoading" class="submit-btn">
						<i class="el-icon-check"></i>
						{{ submitLoading ? '保存中...' : (isCarouselMode ? '创建轮播图' : '保存轮播图') }}
					</el-button>
				</div>
				<div class="header-actions" v-else>
					<el-button @click="back()" class="back-btn">
						<i class="el-icon-back"></i>
						返回列表
					</el-button>
				</div>
			</div>
		</div>

		<!-- 表单内容 -->
		<div class="form-content">
			<el-form
				ref="ruleForm"
				:model="ruleForm"
				:rules="rules"
				label-width="120px"
				class="config-form"
			>
				<!-- 轮播图信息 -->
				<div class="form-section">
					<h3 class="section-title">轮播图信息</h3>
					
					<!-- 配置名称 -->
					<el-form-item label="轮播图名称" prop="name" class="form-item">
						<div class="input-wrapper">
							<div class="input-field" :class="{ 'readonly': type === 'info' }">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M10,22C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.22,15.05 2.27,14.78 2.46,14.63L4.57,12.97C4.53,12.65 4.5,12.33 4.5,12C4.5,11.67 4.53,11.34 4.57,11.03L2.46,9.37C2.27,9.22 2.22,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.78,8.95 21.73,9.22 21.54,9.37L19.43,11.03C19.47,11.34 19.5,11.67 19.5,12C19.5,12.33 19.47,12.65 19.43,12.97L21.54,14.63C21.73,14.78 21.78,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.03 19.05,18.95L16.56,17.94C16.04,18.34 15.5,18.68 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10M11.25,4L10.88,6.61C9.68,6.86 8.62,7.5 7.85,8.39L5.44,7.35L4.69,8.65L6.8,10.2C6.4,11.37 6.4,12.64 6.8,13.8L4.68,15.36L5.43,16.66L7.86,15.62C8.63,16.5 9.68,17.14 10.87,17.38L11.24,20H12.76L13.13,17.39C14.32,17.14 15.37,16.5 16.14,15.62L18.57,16.66L19.32,15.36L17.2,13.81C17.6,12.64 17.6,11.37 17.2,10.2L19.31,8.65L18.56,7.35L16.15,8.39C15.38,7.5 14.32,6.86 13.12,6.62L12.75,4H11.25Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.name" 
									:placeholder="type === 'info' ? '轮播图名称' : '请输入轮播图名称'" 
									:readonly="type === 'info'"
									clearable
									class="form-input"
									maxlength="50"
									show-word-limit
								></el-input>
								<div class="readonly-indicator" v-if="type === 'info'">
									<svg class="lock-icon" viewBox="0 0 24 24">
										<path d="M18,8H17V6A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M15.8,8H8.2V6A3.8,3.8 0 0,1 12,2.2A3.8,3.8 0 0,1 15.8,6V8Z"/>
									</svg>
								</div>
							</div>
							<span class="field-tip">
								{{ type === 'info' ? '轮播图的显示名称' : '请输入轮播图的显示名称，如：首页轮播图1' }}
							</span>
						</div>
					</el-form-item>
				</div>

				<!-- 图片设置 -->
				<div class="form-section">
					<h3 class="section-title">图片设置</h3>
					
					<!-- 配置值 -->
					<el-form-item v-if="type !== 'info'" label="轮播图图片" prop="value" class="form-item image-item">
						<div class="image-upload-wrapper">
							<div class="upload-area">
								<file-upload
									:tip="isCarouselMode ? '点击上传轮播图图片' : '点击上传配置图片'"
									action="file/upload"
									:limit="isCarouselMode ? 1 : 3"
									:multiple="!isCarouselMode"
									:fileUrls="ruleForm.value?ruleForm.value:''"
									@change="valueUploadChange"
									class="image-uploader"
								></file-upload>
							</div>
							<div class="upload-info">
								<h4>上传说明：</h4>
								<ul>
									<li>支持格式：JPG、PNG、GIF</li>
									<li>图片大小：不超过5MB</li>
									<li v-if="isCarouselMode">建议尺寸：1200×600像素</li>
									<li v-else>建议尺寸：根据配置项要求</li>
									<li v-if="isCarouselMode">轮播图建议使用高质量图片</li>
									<li v-else>可上传多张图片，用逗号分隔</li>
								</ul>
								<div class="config-description">
									<p><strong>{{ getConfigDescription(ruleForm.name) }}</strong></p>
								</div>
							</div>
						</div>
					</el-form-item>
					<el-form-item v-else-if="ruleForm.value && type === 'info'" label="轮播图图片" prop="value" class="form-item image-item">
						<div class="config-preview">
							<div class="preview-header">
								<h4>当前轮播图图片</h4>
								<div class="config-description">{{ getConfigDescription(ruleForm.name) }}</div>
							</div>
							<div class="image-gallery">
								<template v-if="ruleForm.value.substring(0,4)==='http'">
									<div class="preview-item">
										<img class="preview-img" :src="ruleForm.value.split(',')[0]" />
										<div class="image-actions">
											<el-button 
												size="mini" 
												icon="el-icon-zoom-in" 
												@click="previewImage(ruleForm.value.split(',')[0])"
											>
												预览
											</el-button>
										</div>
									</div>
								</template>
								<template v-else>
									<div 
										v-for="(item,index) in ruleForm.value.split(',')" 
										v-bind:key="index" 
										class="preview-item"
									>
										<img 
											class="preview-img" 
											:src="item.substring(0,4)==='http' ? item : $base.url+item" 
										/>
										<div class="image-actions">
											<el-button 
												size="mini" 
												icon="el-icon-zoom-in" 
												@click="previewImage(item.substring(0,4)==='http' ? item : $base.url+item)"
											>
												预览
											</el-button>
										</div>
									</div>
								</template>
							</div>
						</div>
					</el-form-item>
					<el-form-item v-else-if="type === 'info'" label="轮播图图片" prop="value" class="form-item">
						<div class="empty-config">
							<i class="el-icon-picture-outline"></i>
							<p>该轮播图暂未设置图片</p>
							<span class="config-desc">{{ getConfigDescription(ruleForm.name) }}</span>
						</div>
					</el-form-item>
				</div>
			</el-form>
		</div>

		<!-- 图片预览对话框 -->
		<el-dialog
			:visible.sync="previewVisible"
			title="图片预览"
			width="60%"
			class="preview-dialog"
		>
			<div class="image-preview-container">
				<img :src="previewImageUrl" class="preview-image" />
			</div>
		</el-dialog>
	</div>
</template>
<script>
// 数字，邮件，手机，url，身份证校验
import { isNumber,isIntNumer,isEmail,isPhone, isMobile,isURL,checkIdCard } from "@/utils/validate";
export default {
	data() {
		let self = this
		var validateIdCard = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!checkIdCard(value)) {
				callback(new Error("请输入正确的身份证号码"));
			} else {
				callback();
			}
		};
		var validateUrl = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isURL(value)) {
				callback(new Error("请输入正确的URL地址"));
			} else {
				callback();
			}
		};
		var validateMobile = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isMobile(value)) {
				callback(new Error("请输入正确的手机号码"));
			} else {
				callback();
			}
		};
		var validatePhone = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isPhone(value)) {
				callback(new Error("请输入正确的电话号码"));
			} else {
				callback();
			}
		};
		var validateEmail = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isEmail(value)) {
				callback(new Error("请输入正确的邮箱地址"));
			} else {
				callback();
			}
		};
		var validateNumber = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isNumber(value)) {
				callback(new Error("请输入数字"));
			} else {
				callback();
			}
		};
		var validateIntNumber = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isIntNumer(value)) {
				callback(new Error("请输入整数"));
			} else {
				callback();
			}
		};
		return {
			id: '',
			type: '',
			submitLoading: false, // 提交加载状态
			previewVisible: false, // 图片预览对话框显示状态
			previewImageUrl: '', // 预览图片地址
			
			ro:{
				name : false,
			},
			
			
			ruleForm: {
				name: '',
				value: '',
			},
		
			
			rules: {
				name: [
					{ required: true, message: '名称不能为空', trigger: 'blur' },
					{ min: 2, max: 50, message: '名称长度在 2 到 50 个字符', trigger: 'blur' }
				],
				value: [
					{ required: false, message: '请上传配置图片', trigger: 'change' }
				],
			}
		};
	},
	props: ["parent"],
	computed: {
		// 判断是否为轮播图模式
		isCarouselMode() {
			return this.type === 'carousel';
		}
	},
	created() {
	},
	methods: {
		
		// 下载
		download(file){
			window.open(`${file}`)
		},
		// 初始化
		init(id,type) {
			if (id) {
				this.id = id;
				this.type = type;
			} else {
				this.id = '';
				this.type = type || 'add';
			}
			
			// 如果是新增轮播图模式
			if (this.type === 'carousel') {
				this.ruleForm = {
					name: '',
					value: ''
				};
				return;
			}
			
			if(this.type=='info'||this.type=='else'){
				this.info(id);
			}else if(this.type=='logistics'){
				this.logistics=false;
				this.info(id);
			}else if(this.type=='cross'){
				var obj = this.$storage.getObj('crossObj');
				for (var o in obj){
						if(o=='name'){
							this.ruleForm.name = obj[o];
							this.ro.name = true;
							continue;
						}
						}
				}
		},
    // 多级联动参数

    info(id) {
      this.$http({
        url: `config/info/${id}`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
        this.ruleForm = data.data;
        console.log('Config编辑数据:', this.ruleForm);
        //解决前台上传图片后台不显示的问题 - 修复正则表达式
        // 原来的正则匹配 ../../../upload，但数据库存储的是 upload/
        // 所以我们需要检查并替换 upload/ 开头的路径
        if(this.ruleForm.value) {
          console.log('替换前的value:', this.ruleForm.value);
          // 如果value以upload/开头且不是完整URL，则添加完整前缀
          if(this.ruleForm.value.startsWith('upload/') && !this.ruleForm.value.startsWith('http')) {
            this.ruleForm.value = 'http://ht.yiminkangjian.top/taoziyiyuan/' + this.ruleForm.value;
          }
          console.log('替换后的value:', this.ruleForm.value);
        }
        } else {
          this.$message.error(data.msg);
        }
      });
    },


    // 提交
    onSubmit() {




	if(this.ruleForm.value!=null) {
		this.ruleForm.value = this.ruleForm.value.replace(new RegExp(this.$base.url,"g"),"");
	}

var objcross = this.$storage.getObj('crossObj');

      //更新跨表属性
       var crossuserid;
       var crossrefid;
       var crossoptnum;
       if(this.type=='cross'){
                var statusColumnName = this.$storage.get('statusColumnName');
                var statusColumnValue = this.$storage.get('statusColumnValue');
                if(statusColumnName!='') {
                        var obj = this.$storage.getObj('crossObj');
                       if(statusColumnName && !statusColumnName.startsWith("[")) {
                               for (var o in obj){
                                 if(o==statusColumnName){
                                   obj[o] = statusColumnValue;
                                 }
                               }
                               var table = this.$storage.get('crossTable');
                             this.$http({
                                 url: `${table}/update`,
                                 method: "post",
                                 data: obj
                               }).then(({ data }) => {});
                       } else {
                               crossuserid=this.$storage.get('userid');
                               crossrefid=obj['id'];
                               crossoptnum=this.$storage.get('statusColumnName');
                               crossoptnum=crossoptnum.replace(/\[/,"").replace(/\]/,"");
                        }
                }
        }
       this.submitLoading = true;

       this.$refs["ruleForm"].validate(valid => {
         if (valid) {
		 if(crossrefid && crossuserid) {
			 this.ruleForm.crossuserid = crossuserid;
			 this.ruleForm.crossrefid = crossrefid;
			let params = { 
				page: 1, 
				limit: 10, 
				crossuserid:this.ruleForm.crossuserid,
				crossrefid:this.ruleForm.crossrefid,
			} 
			this.$http({ 
				url: "config/page", 
				method: "get", 
				params: params 
			}).then(({ 
				data 
			}) => { 
				if (data && data.code === 0) { 
				       if(data.data.total>=crossoptnum) {
					     this.submitLoading = false;
					     this.$message.error(this.$storage.get('tips'));
					       return false;
				       } else {
					 this.$http({
					   url: `config/${!this.ruleForm.id ? "save" : "update"}`,
					   method: "post",
					   data: this.ruleForm
					 }).then(({ data }) => {
					   this.submitLoading = false;
					   if (data && data.code === 0) {
					     this.$message({
					       message: "操作成功",
					       type: "success",
					       duration: 1500,
					       onClose: () => {
						 this.parent.showFlag = true;
						 this.parent.addOrUpdateFlag = false;
						 this.parent.configCrossAddOrUpdateFlag = false;
						 this.parent.search();
						 this.parent.contentStyleChange();
					       }
					     });
					   } else {
					     this.$message.error(data.msg);
					   }
					 });

				       }
				} else { 
				} 
			});
		 } else {
			 this.$http({
			   url: `config/${!this.ruleForm.id ? "save" : "update"}`,
			   method: "post",
			   data: this.ruleForm
			 }).then(({ data }) => {
			   this.submitLoading = false;
			   if (data && data.code === 0) {
			     this.$message({
			       message: "操作成功",
			       type: "success",
			       duration: 1500,
			       onClose: () => {
				 this.parent.showFlag = true;
				 this.parent.addOrUpdateFlag = false;
				 this.parent.configCrossAddOrUpdateFlag = false;
				 this.parent.search();
				 this.parent.contentStyleChange();
			       }
			     });
			   } else {
			     this.$message.error(data.msg);
			   }
			 });
		 }
         } else {
           this.submitLoading = false;
         }
       });
    },
    // 获取uuid
    getUUID () {
      return new Date().getTime();
    },
    // 返回
    back() {
      this.parent.showFlag = true;
      this.parent.addOrUpdateFlag = false;
      this.parent.configCrossAddOrUpdateFlag = false;
      this.parent.contentStyleChange();
    },
    valueUploadChange(fileUrls) {
	    this.ruleForm.value = fileUrls;
    },

    // 获取配置项描述
    getConfigDescription(name) {
      // 如果是轮播图模式，返回轮播图描述
      if (this.isCarouselMode && !name) {
        return '轮播图图片，建议尺寸：1200×600像素，支持JPG、PNG格式';
      }
      
      const descriptions = {
        'logo': '网站Logo图片，建议尺寸：200×60像素',
        'banner': '首页Banner图片，建议尺寸：1200×400像素',
        'footerLogo': '底部Logo图片，建议尺寸：150×50像素',
        'aboutUsImage': '关于我们页面背景图，建议尺寸：1200×600像素',
        'contactUsImage': '联系我们页面背景图，建议尺寸：1200×600像素',
        'newsImage': '新闻页面背景图，建议尺寸：1200×400像素',
        'productImage': '产品页面背景图，建议尺寸：1200×600像素',
        'serviceImage': '服务页面背景图，建议尺寸：1200×600像素',
        'partnerImage': '合作伙伴页面图片，建议尺寸：800×400像素',
        'galleryImage': '画廊页面背景图，建议尺寸：1200×600像素',
        'blogImage': '博客页面背景图，建议尺寸：1200×400像素',
        'faqImage': '常见问题页面背景图，建议尺寸：1200×400像素',
        'privacyPolicyImage': '隐私政策页面背景图，建议尺寸：1200×400像素',
        'termsOfServiceImage': '服务条款页面背景图，建议尺寸：1200×400像素',
        'cookiePolicyImage': 'Cookie政策页面背景图，建议尺寸：1200×400像素',
        'copyrightImage': '版权页面背景图，建议尺寸：1200×400像素',
        'disclaimerImage': '免责声明页面背景图，建议尺寸：1200×400像素'
      };
      
      // 检查是否是轮播图类型的名称
      if (name && (name.includes('轮播图') || name.includes('carousel') || name.includes('banner'))) {
        return '轮播图图片，建议尺寸：1200×600像素，支持JPG、PNG格式';
      }
      
      return descriptions[name] || '系统配置项图片';
    },

    // 预览图片
    previewImage(imageUrl) {
      this.previewImageUrl = imageUrl;
      this.previewVisible = true;
    },

    // 获取页面标题
    getPageTitle() {
      if (this.type === 'info') {
        return '轮播图详情';
      } else if (this.type === 'carousel') {
        return '新增轮播图';
      } else {
        return '编辑轮播图';
      }
    },

    // 获取面包屑文本
    getBreadcrumbText() {
      if (this.type === 'info') {
        return '查看详情';
      } else if (this.type === 'carousel') {
        return '新增轮播图';
      } else {
        return '编辑轮播图';
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.config-form-container {
	background: #f8fafc;
	min-height: 100vh;
	padding: 24px;
}

// 页面头部
.page-header {
	margin-bottom: 24px;
	
	.header-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: white;
		padding: 20px 24px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

		.header-left {
			display: flex;
			align-items: center;
			gap: 16px;
			flex: 1;

			.back-button {
				width: 40px;
				height: 40px;
				background: #f8fafc;
				border: 1px solid #e2e8f0;
				border-radius: 8px;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				transition: all 0.2s ease;
				color: #64748b;

				&:hover {
					background: #f1f5f9;
					border-color: #cbd5e1;
					color: #475569;
				}

				&:active {
					background: #e2e8f0;
				}

				i {
					font-size: 16px;
				}
			}

			.header-info {
				.page-title {
					font-size: 20px;
					font-weight: 600;
					color: #1e293b;
					margin: 0 0 4px 0;
					line-height: 1.2;
				}

				.breadcrumb {
					display: flex;
					align-items: center;
					gap: 8px;
					font-size: 13px;
					color: #64748b;

					.breadcrumb-item {
						color: #64748b;
					}

					.breadcrumb-current {
						color: #6b7280;
						font-weight: 500;
					}

					i {
						font-size: 12px;
						color: #94a3b8;
					}
				}
			}
		}

		.header-actions {
			display: flex;
			gap: 12px;
			align-items: center;

			.el-button {
				padding: 10px 20px;
				font-weight: 500;
				border-radius: 6px;
				font-size: 14px;
				display: flex;
				align-items: center;
				gap: 6px;

				i {
					font-size: 14px;
				}
			}

			.cancel-btn {
				color: #6b7280;
				border-color: #d1d5db;
				background: white;

				&:hover {
					color: #374151;
					border-color: #9ca3af;
					background: #f9fafb;
				}
			}

			.submit-btn {
				background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
				border: none;
				color: white;
				box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
				transition: all 0.3s ease;

				&:hover {
					transform: translateY(-1px);
					box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
				}

				&:disabled {
					background: #d1d5db;
					border-color: #d1d5db;
					color: #9ca3af;
					transform: none;
					box-shadow: none;
				}
			}

			.back-btn {
				background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
				border: none;
				color: white;
				box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
				transition: all 0.3s ease;

				&:hover {
					transform: translateY(-1px);
					box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
				}
			}
		}
	}
}

// 表单内容
.form-content {
	background: white;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	overflow: hidden;

	.config-form {
		padding: 0;

		// 表单区块
		.form-section {
			padding: 24px;
			border-bottom: 1px solid #f1f5f9;

			&:last-child {
				border-bottom: none;
			}

			.section-title {
				font-size: 16px;
				font-weight: 600;
				color: #1e293b;
				margin: 0 0 20px 0;
				padding-bottom: 12px;
				border-bottom: 2px solid #6b7280;
				display: inline-block;
			}
		}

		// 表单项
		.form-item {
			margin-bottom: 24px;

			&:last-child {
				margin-bottom: 0;
			}

			:deep(.el-form-item__label) {
				font-weight: 600;
				color: #374151;
				font-size: 14px;
				line-height: 1.5;
				padding: 0 12px 0 0;
			}

			:deep(.el-form-item__content) {
				line-height: 1.5;
			}

			// 输入框包装器
			.input-wrapper {
				.input-field {
					position: relative;
					display: flex;
					align-items: center;
					background: #f8fafc;
					border: 1px solid #e2e8f0;
					border-radius: 6px;
					transition: all 0.2s ease;

					&:not(.readonly):hover {
						border-color: #cbd5e1;
					}

					&:not(.readonly):focus-within {
						border-color: #6b7280;
						background: white;
						box-shadow: 0 0 0 3px rgba(107, 114, 128, 0.1);
					}

					&.readonly {
						background: #f8fafc;
						border-color: #e2e8f0;
					}

					.field-icon {
						width: 16px;
						height: 16px;
						margin: 0 12px;
						fill: #6b7280;
						flex-shrink: 0;
					}

					.form-input {
						flex: 1;

						:deep(.el-input__inner) {
							border: none;
							padding: 12px 0;
							font-size: 14px;
							line-height: 1.5;
							color: #6b7280;
							background: transparent;

							&[readonly] {
								background: transparent;
								color: #6b7280;
								cursor: not-allowed;
							}
						}
					}

					.readonly-indicator {
						margin-right: 12px;
						display: flex;
						align-items: center;
						
						.lock-icon {
							width: 14px;
							height: 14px;
							fill: #94a3b8;
						}
					}
				}

				.field-tip {
					display: block;
					margin-top: 6px;
					font-size: 12px;
					color: #6b7280;
					line-height: 1.4;
				}
			}

			// 图片相关
			&.image-item {
				.image-upload-wrapper {
					display: flex;
					gap: 24px;
					align-items: flex-start;

					.upload-area {
						flex: 1;
					}

					.upload-info {
						flex: 0 0 350px;
						background: #f8fafc;
						padding: 20px;
						border-radius: 8px;
						border: 1px solid #e2e8f0;

						h4 {
							font-size: 14px;
							font-weight: 600;
							color: #374151;
							margin: 0 0 12px 0;
						}

						ul {
							margin: 0 0 16px 0;
							padding: 0 0 0 16px;

							li {
								font-size: 12px;
								color: #6b7280;
								line-height: 1.6;
								margin-bottom: 4px;

								&:last-child {
									margin-bottom: 0;
								}
							}
						}

						.config-description {
							padding: 12px;
							background: #f3f4f6;
							border-radius: 6px;
							border: 1px solid #d1d5db;

							p {
								margin: 0;
								font-size: 12px;
								color: #374151;
								line-height: 1.5;
							}
						}
					}
				}

				.config-preview {
					.preview-header {
						margin-bottom: 16px;

						h4 {
							font-size: 14px;
							font-weight: 600;
							color: #374151;
							margin: 0 0 4px 0;
						}

						.config-description {
							font-size: 12px;
							color: #6b7280;
							line-height: 1.4;
						}
					}

					.image-gallery {
						display: flex;
						gap: 16px;
						flex-wrap: wrap;

						.preview-item {
							position: relative;
							display: flex;
							flex-direction: column;
							align-items: center;
							padding: 12px;
							background: #f8fafc;
							border: 1px solid #e2e8f0;
							border-radius: 8px;

							.preview-img {
								width: 120px;
								height: 120px;
								object-fit: cover;
								border-radius: 6px;
								border: 1px solid #d1d5db;
								margin-bottom: 8px;
							}

							.image-actions {
								.el-button {
									font-size: 11px;
									padding: 4px 8px;
								}
							}
						}
					}
				}
			}

			// 空配置状态
			.empty-config {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				padding: 40px 20px;
				background: #f8fafc;
				border: 2px dashed #d1d5db;
				border-radius: 8px;
				color: #9ca3af;
				text-align: center;

				i {
					font-size: 48px;
					margin-bottom: 12px;
					color: #d1d5db;
				}

				p {
					font-size: 14px;
					color: #6b7280;
					margin: 0 0 8px 0;
					font-weight: 500;
				}

				.config-desc {
					font-size: 12px;
					color: #9ca3af;
					line-height: 1.4;
				}
			}
		}

		// 错误状态
		:deep(.el-form-item.is-error) {
			.input-field {
				border-color: #ef4444;

				&:focus-within {
					border-color: #ef4444;
					box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
				}
			}
		}

		// 必填标识
		:deep(.el-form-item.is-required) {
			.el-form-item__label::before {
				content: '*';
				color: #ef4444;
				margin-right: 4px;
			}
		}
	}
}

// 图片预览对话框
.preview-dialog {
	:deep(.el-dialog) {
		border-radius: 8px;
	}

	:deep(.el-dialog__header) {
		background: #f8fafc;
		border-bottom: 1px solid #e5e7eb;
		padding: 16px 24px;

		.el-dialog__title {
			font-weight: 600;
			color: #1e293b;
		}
	}

	:deep(.el-dialog__body) {
		padding: 24px;
	}

	.image-preview-container {
		text-align: center;

		.preview-image {
			max-width: 100%;
			max-height: 500px;
			border-radius: 8px;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		}
	}
}

// 响应式设计
@media (max-width: 1024px) {
	.config-form-container {
		padding: 20px;
	}

	.form-content {
		.config-form {
			.form-section {
				padding: 20px;
			}

			.form-item {
				&.image-item {
					.image-upload-wrapper {
						flex-direction: column;
						gap: 16px;

						.upload-info {
							flex: 1;
						}
					}
				}
			}
		}
	}
}

@media (max-width: 768px) {
	.config-form-container {
		padding: 16px;
	}

	.page-header {
		.header-content {
			flex-direction: column;
			gap: 16px;
			align-items: stretch;

			.header-left {
				justify-content: flex-start;
			}

			.header-actions {
				justify-content: center;
				order: -1;

				.el-button {
					flex: 1;
					max-width: 120px;
				}
			}
		}
	}

	.form-content {
		.config-form {
			:deep(.el-form-item__label) {
				text-align: left;
				float: none;
				display: block;
				width: 100% !important;
				margin-bottom: 8px;
				padding: 0;
			}

			:deep(.el-form-item__content) {
				margin-left: 0 !important;
			}

			.form-section {
				padding: 16px;
			}
		}
	}
}

@media (max-width: 480px) {
	.config-form-container {
		padding: 12px;
	}

	.page-header {
		.header-content {
			padding: 16px;

			.header-left {
				.back-button {
					width: 36px;
					height: 36px;

					i {
						font-size: 14px;
					}
				}

				.header-info {
					.page-title {
						font-size: 18px;
					}

					.breadcrumb {
						font-size: 12px;
					}
				}
			}

			.header-actions {
				.el-button {
					padding: 8px 16px;
					font-size: 13px;

					i {
						font-size: 13px;
					}
				}
			}
		}
	}

	.form-content {
		.config-form {
			.form-section {
				padding: 12px;

				.section-title {
					font-size: 15px;
					margin-bottom: 16px;
				}
			}

			.form-item {
				margin-bottom: 20px;

				.input-wrapper {
					.input-field {
						.field-icon {
							width: 14px;
							height: 14px;
							margin: 0 10px;
						}

						.form-input {
							:deep(.el-input__inner) {
								padding: 10px 0;
								font-size: 14px;
							}
						}
					}

					.field-tip {
						font-size: 11px;
					}
				}

				&.image-item {
					.config-preview {
						.image-gallery {
							.preview-item {
								.preview-img {
									width: 80px;
									height: 80px;
								}
							}
						}
					}
				}

				.empty-config {
					padding: 30px 16px;

					i {
						font-size: 36px;
					}

					p {
						font-size: 13px;
					}

					.config-desc {
						font-size: 11px;
					}
				}
			}
		}
	}

	.preview-dialog {
		:deep(.el-dialog) {
			width: 90% !important;
			margin: 20px;
		}

		:deep(.el-dialog__body) {
			padding: 16px;
		}
	}
}
</style>
